import gql from 'graphql-tag'

export default gql`
  query GetMarketplaceProductFacets($categoryPath: [String!]!) {
    category: marketplaceCategory(path: $categoryPath) {
      path {
        code
        title
      }
      title
      height
      children {
        path {
          code
          title
        }
        title
        height
      }
    }
    productFacets: marketplaceProductFacets(categoryPath: $categoryPath) {
      id
      type
      title
      options {
        id
        label
      }
      searchFieldPlaceholder
    }
  }
`
